/* eslint-disable react/require-default-props */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable class-methods-use-this */
/* global document, window, fetch */
import React, { useEffect, useLayoutEffect, useState, useContext } from "react";
import PropTypes, { func } from "prop-types";
import "../Slider/SliderComponent.css";
import "./ListComponent.css";
import ItemsCarousel from "react-items-carousel";
import range from "lodash/range";
import { createImageChildren } from "../Slider/SliderItem";

//Context
import { AuthContext } from "./../../context/AuthContext";

function ListComponent(props) {
  const { authenticatedUser } = useContext(AuthContext);
  const {
    // eslint-disable-next-line react/prop-types
    isSearch,
    contentType,
    recentlyViewed,
    searchResults,
    big,
    listPageCallback,
    onListPage,
    parentCallback,
    onlyShowPublicProjects,
  } = props;

  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const [chevronWidth, setChevronWidth] = useState(45);
  const [noOfChildren, setNoOfChildren] = useState(20);
  const [numberOfCards, setNumberOfCards] = useState(5);
  const [slidesToScroll, setSlideToScroll] = useState(5);
  const [componentProps, setComponentProps] = useState({
    infiniteLoop: false,
    gutter: 8,
    activePosition: "left",
    disableSwipe: true,
    alwaysShowChevrons: false,
    outsideChevron: true,
    showSlither: false,
    firstAndLastGutter: false,
  });
  const [isLoaded, setIsLoaded] = useState(false);
  const [projectData, setProjectData] = useState([
    {
      projekt_ID: "",
      projekt_titel: "",
      untertitel: "",
      rechte_ring: null,
      stupro_ID: null,
      medianight_semester: "",
    },
  ]);
  const [error, setError] = useState(null);
  const [windowWidth, setWindowWidth] = useState(
    window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
  );
  const [uibreakpoints, setUibreakpoints] = useState({
    phone: 600,
    phoneLarge: 780,
    tablet: 960,
    desktop: 1440,
    desktopMedium: 1680,
    desktopLarge: 1920,
  });

  useLayoutEffect(() => {
    function updateLayout() {
      setLayout(big, window.innerWidth);
    }

    window.addEventListener("resize", updateLayout);
    window.addEventListener("load", updateLayout);
    updateLayout();
    return function cleanup() {
      window.removeEventListener("resize", updateLayout);
      window.removeEventListener("load", updateLayout);
    };
  }, []);

  useEffect(() => {
    fetchDataSequence();
  }, []);

  useEffect(() => {
    if (searchResults) {
      setIsLoaded(true);
      setProjectData(searchResults);
      setNoOfChildren(searchResults.length);
    }
  }, [searchResults]);

  function getContentType(type, recentlyViewed) {
    const sqlQuery = `${process.env.REACT_APP_API}/`;
    const dtmlMethod = type;
    const params = formatQueryParams(recentlyViewed);
    return sqlQuery + dtmlMethod + params;
  }

  function setLayout(isBig, windowWidth) {
    if (windowWidth < uibreakpoints.phone) {
      setChevronWidth(10);

      if (isBig) {
        setNumberOfCards(1);
      } else {
        setNumberOfCards(2);
      }
    } else if (
      windowWidth > uibreakpoints.phone &&
      windowWidth < uibreakpoints.phoneLarge
    ) {
      setChevronWidth(20);

      if (isBig) {
        setNumberOfCards(2);
      } else {
        setNumberOfCards(3);
      }
    } else if (
      windowWidth > uibreakpoints.phoneLarge &&
      windowWidth < uibreakpoints.tablet
    ) {
      if (isBig) {
        setNumberOfCards(3);
      } else {
        setNumberOfCards(4);
      }
    } else if (
      windowWidth > uibreakpoints.tablet &&
      windowWidth < uibreakpoints.desktop
    ) {
      if (isBig) {
        setNumberOfCards(3);
      } else {
        setNumberOfCards(5);
      }
    } else if (
      windowWidth > uibreakpoints.desktop &&
      windowWidth < uibreakpoints.desktopMedium
    ) {
      if (isBig) {
        setNumberOfCards(4);
      } else {
        setNumberOfCards(6);
      }
    } else if (
      windowWidth > uibreakpoints.desktopMedium &&
      windowWidth < uibreakpoints.desktopLarge
    ) {
      if (isBig) {
        setNumberOfCards(4);
      } else {
        setNumberOfCards(7);
      }
    } else if (isBig) {
      setNumberOfCards(5);
    } else {
      setNumberOfCards(8);
    }
  }

  function fetchDataSequence() {
    if (isSearch) {
      setIsLoaded(true);
      setProjectData(searchResults);
      setNoOfChildren(searchResults.length);
    } else {
      const projectsQuery = getContentType(contentType, recentlyViewed);

      fetch(projectsQuery)
        .then((response) => response.json())
        .then(
          (result) => {
            setIsLoaded(true);
            setProjectData(result);
            setNoOfChildren(result.length);
          },
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        );
    }
  }

  function formatQueryParams(projektParams) {
    let pString = "&projekt_ID=";
    if (projektParams > "" && projektParams !== undefined) {
      for (let i = 0; i <= projektParams.length - 1; i += 1) {
        if (i === projektParams.length - 1 && i !== 0) {
          pString += `%2C${projektParams[i]}`;
        } else {
          // eslint-disable-next-line no-unused-expressions
          i >= 1
            ? (pString += `%2C${projektParams[i]}`)
            : (pString += projektParams[i]);
        }
      }
      return pString;
    }
    return "";
  }

  function requestChangeURL(value) {
    passChangedProjectIdToParent(value);
  }

  function passChangedProjectIdToParent(passedID) {
    if (parentCallback) {
      parentCallback(passedID);
    }
  }

  const tempCounter = 0;

  const children = createImageChildren(
    noOfChildren,
    projectData,
    numberOfCards,
    requestChangeURL,
    authenticatedUser.auth_state,
    listPageCallback,
    onListPage
  );

  if (error) {
    return <p style={{ color: "white" }}>{error.message}</p>;
  }
  if (!isLoaded) {
    return (
      <div className="slider-container">
        <div style={{ padding: `0 ${chevronWidth}px`, marginTop: "40px" }}>
          <div className="dynamic-loader-container">
            <div className="dynamic-loader">
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
            </div>
          </div>
        </div>
      </div>
    );
  }
  try {
    return (
      <div>
        {range(0, children.length, numberOfCards).map(() => (
          <div className="sl-slider-container">
            <div style={{ padding: `0 ${chevronWidth}px`, marginTop: "40px" }}>
              <ItemsCarousel
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...componentProps}
                numberOfCards={numberOfCards}
                slidesToScroll={0}
                classes={{
                  wrapper: "sl-wrapper",
                  itemsWrapper: "sl-itemsWrapper",
                  itemsInnerWrapper: "sl-itemsInnerWrapper",
                }}
                leftChevron={null}
                rightChevron={null}
                outsideChevron
                chevronWidth={chevronWidth}
              >
                {children.splice(tempCounter, tempCounter + numberOfCards)}
              </ItemsCarousel>
            </div>
          </div>
        ))}
      </div>
    );
  } catch (renderError) {
    return <div />;
  }
}

export default ListComponent;

ListComponent.propTypes = {
  // userAuth: PropTypes.number.isRequired,
  isSearch: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  searchResults: PropTypes.object.isRequired,
  listPageCallback: PropTypes.func.isRequired,
  onListPage: PropTypes.func.isRequired,
  parentCallback: PropTypes.func,
  contentType: PropTypes.string,
};
